module.exports = __webpack_public_path__ + "img/login-bg-img.1f690a0d.png";